import styled from 'styled-components';

export const RetailerRegistrationPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const RetailerRegistrationPageInnerWrapper = styled.div`
  max-width: 840px;
  width: 100%;
`;
